import React, { useState, useEffect, useRef } from 'react';
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import styled from "styled-components";
import Button from "../button/Button";
import s from './MenuComponent.module.css';
import arrow from '../../../assets/img/arrow_back.svg';
import history from "../../../assets/img/history.svg";
import { RootState, useAppDispatch } from "../../../store/store";
import { selectCurrentProject } from "../../../store/selectors/projectSelectors";
import integration from '../../../assets/img/export_notes.svg';
import ContextMenu from "../context-menu/ContextMenu";
import linkedin from '../../../assets/img/linkedin_color.svg'
import {exportProject} from "../../../store/slices/projectSlice";
import PreviewButton from "../preview-button/PreviewButton";
export const StyledMenuComponent = styled.div`
    .${s.top_container} {
       background: ${({ theme }) => theme.menuContainer};
        color: ${({ theme }) => theme.textColor};
    }
`;

const MenuComponent: React.FC = () => {

    const [isOpenExport, setIsOpenExport] = useState(false);
    const [isOpenShare, setIsOpenShare] = useState(false);
    const [menuPosition, setMenuPosition] = useState({ x: 0, y: 0 });
    const currentProject = useSelector(selectCurrentProject);
    const dispatch = useAppDispatch();
    const menuRef = useRef<HTMLDivElement>(null);
    const navigate = useNavigate();

    const handleOpenMenu = (event: React.MouseEvent<HTMLButtonElement>, type: 'export' | 'share'|'post') => {
        event.preventDefault();

        const button = event.currentTarget;
        const rect = button.getBoundingClientRect();



        if (type === 'export') {
            setIsOpenExport(true);
            setIsOpenShare(false);
            setMenuPosition({ x: rect.left-280, y: rect.bottom+10});

        } else if (type === 'share') {
            setIsOpenShare(true);
            setIsOpenExport(false);
            setMenuPosition({ x: rect.left-200, y: rect.bottom+15});
        }
    };

    const handleCloseMenus = (event: MouseEvent) => {
        if (menuRef.current && !menuRef.current.contains(event.target as Node)) {
            setIsOpenExport(false);
            setIsOpenShare(false);
        }
    };

    useEffect(() => {
        document.addEventListener('mousedown', handleCloseMenus);
        return () => {
            document.removeEventListener('mousedown', handleCloseMenus);
        };
    }, []);
        const handleExport = async () => {


        try {
            if(currentProject?.id){
                await dispatch(exportProject(currentProject?.id)).unwrap();
                console.log('Export completed successfully');
            }

        } catch (error) {
            console.error('Export failed:', error);
        }
    };
    const handleCreateNewPost=()=>{
        navigate('/onboarding')
    }
    return (
        <StyledMenuComponent>
            <div className={s.top_container}>
                <button className={s.post_btn} onClick={handleCreateNewPost}>Create Post</button>

                <div className={s.right_container}>

                    <div className={s.background}>
                        {/*<button className={s.btn} onClick={(e) => handleOpenMenu(e, 'post')}>*/}
                        {/*    <img*/}
                        {/*        src={history}*/}
                        {/*        className={s.img}*/}
                        {/*        alt="History"*/}
                        {/*    />*/}
                        {/*</button>*/}
                    </div>

                    <div className={s.background}>
                        {/*<button className={s.btn} onClick={(e) => handleOpenMenu(e, 'post')}>*/}
                        {/*    <img src={integration} className={s.img}/>*/}
                        {/*</button>*/}
                    </div>

                    <div className={s.exp_button}>
                        <Button
                            onClick={(e) => handleOpenMenu(e, 'export')}
                            text="Export"
                            type="secondary"
                            style={{height: '30px'}}
                        />
                    </div>
                    <div className={s.preview_button}>
                        <PreviewButton isBackground={false}/>
                    </div>


                    {/*<Button*/}
                    {/*    style={{height: '30px'}}*/}
                    {/*    onClick={(e) => handleOpenMenu(e, 'share')}*/}
                    {/*    text="Share"*/}
                    {/*/>*/}
                </div>

                <div ref={menuRef}>
                    <ContextMenu position={menuPosition} isOpen={isOpenExport}>
                        <div className={s.context_export}>
                            <p>Click the format to export in.</p>
                            <p onClick={()=>handleExport()} className={s.export}>.pdf</p>
                      </div>
                    </ContextMenu>

                    <ContextMenu position={menuPosition} isOpen={isOpenShare}>
                        <div className={s.context_share}>
                            <p>Invite others by sharing their email address or copying an invite.</p>
                            <input placeholder={'Enter email'}/>
                            <p>Or</p>
                            <Button
                                text={'Copy Invitation'}
                                onClick={()=>console.log('copy')} />
                        </div>
                    </ContextMenu>
                </div>
            </div>
        </StyledMenuComponent>
    );
};

export default MenuComponent;
